import BaseComponent from "components/base-component"
import classNames from "classnames"
import instanceOfClassName from "@kaspernj/api-maker/build/instance-of-class-name"
import Link from "@kaspernj/api-maker/build/link"
import PropTypes from "prop-types"
import React from "react"

export default class ComponentsCountryStatesLink extends BaseComponent {
  static defaultProps = {
    adminLayout: false,
    userLayout: false
  }

  static propTypes = {
    adminLayout: PropTypes.bool.isRequired,
    className: PropTypes.string,
    countryState: instanceOfClassName("CountryState").isRequired,
    userLayout: PropTypes.bool.isRequired
  }

  render() {
    const {adminLayout, children, className, countryState, userLayout, ...restProps} = this.props
    const generatedClassName = classNames("components--country-states--link", className)
    const to = this.to()

    if (to) {
      return (
        <Link className={generatedClassName} to={to} {...restProps}>
          {children || countryState.name()}
        </Link>
      )
    }

    return (
      <span className={generatedClassName} {...restProps}>
        {children || countryState.name()}
      </span>
    )
  }

  to = () => "#"
}
